<template>
  <v-card :loading="weekStats.length == 0" hover tile ref="last-week-stats">
    <v-card-title>Llamadas exitosas</v-card-title>
    <v-card-text>
      <canvas id="chart" ref="chart" style="height: 280px"></canvas>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "LastWeekStats",

  computed: {
    weekText() {
      return this.weekStats[0]
        ? `${this.weekStats[0].day} - ${
            this.weekStats[this.weekStats.length - 1].day
          }`
        : "";
    },

    ...mapGetters({
      weekStats: "getWeekStats"
    })
  },

  methods: {
    drawChart() {
      new Chart(this.$refs.chart.getContext("2d"), {
        type: "line",

        // The data for our dataset
        data: {
          labels: this.weekStats.map(({ day }) => day),
          datasets: [
            {
              borderColor: "rgb(255, 99, 132)",
              data: this.weekStats.map(({ total }) => total),
              fill: false,
              label: ""
            }
          ]
        },

        // Configuration options go here
        options: {
          maintainAspectRatio: false,

          scales: {
            yAxes: [
              {
                scaleLabel: {
                  display: false,
                  labelString: "# llamadas"
                }
              }
            ],
            xAxes: [
              {
                scaleLabel: {
                  display: true,
                  labelString: "Fecha"
                }
              }
            ]
          }
        }
      });
    },
    ...mapActions(["seeWeekStats"])
  },

  async mounted() {
    await this.seeWeekStats();
    this.drawChart();

    this.$emit("intro", {
      id: 3,
      name: "last-week-stats",
      element: this.$refs["last-week-stats"].$el,
      str: "Estadísticas de las llamadas de la última semana.",
      step: 3
    });
  }
};
</script>
